/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import { BackpackThemedContentPanelWithFullHeader } from 'components/common/ContentPanel';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';

const NotFoundError = (props) => {
  return (
    <BackpackThemedContentPanelWithFullHeader
      isFixedWidth
      goBack={props.goBack}
      titlePhrase={{ id: 'unexpected-error.container.headline' }}
    >
      <WhiteCardWithWidePadding>
        <section>
          <FormattedMessage id="error.api.404-not-found.message" />
        </section>
      </WhiteCardWithWidePadding>
    </BackpackThemedContentPanelWithFullHeader>
  );
}

export default NotFoundError;